<div class="popup modal-header d-inline-block  pb-0 w-100 m-auto">



    <div class="p-4 " >
      <p class="mb-5 text-center fw-bold">{{errorMessage}}
      </p>
      <div class="mb-4 d-flex  gap-3 resend">
        <button class="btn btn-resend w-100 " (click)="close()">Close</button>
      </div>
    </div>
  </div>
